import {Product} from '../types';

// Builds the variables payload for the createProduct mutation. Whitelists the
// fields declared on backend CreateProductInput (products.graphql) so that
// frontend-only fields (billingProviderId, billingProviderRecordId, current,
// baseFee, included) and server-managed fields (id, created, updated,
// createdByUsername, createdByUser, lineItems) cannot leak into the mutation
// variables and trigger AppSync's "field not defined for input object type"
// validation error. See FNP-29.
export const buildCreateProductInput = (values: Product): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        name: values.name,
        status: values.status,
    };
    if (values.shortDescription !== undefined) input.shortDescription = values.shortDescription;
    if (values.longDescription !== undefined) input.longDescription = values.longDescription;
    if (values.productImage !== undefined) input.productImage = values.productImage;
    if (values.freeTrial !== undefined) input.freeTrial = values.freeTrial;
    return input;
};

// Builds the variables payload for the updateProduct mutation. Mirrors the
// create whitelist and additionally includes id (required by
// UpdateProductInput).
export const buildUpdateProductInput = (values: Product): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        id: values.id,
        name: values.name,
        status: values.status,
    };
    if (values.shortDescription !== undefined) input.shortDescription = values.shortDescription;
    if (values.longDescription !== undefined) input.longDescription = values.longDescription;
    if (values.productImage !== undefined) input.productImage = values.productImage;
    if (values.freeTrial !== undefined) input.freeTrial = values.freeTrial;
    return input;
};
